import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { ServiceAreasService } from '../../../service/service-areas-service/service-areas.service';
import { sweetAlert } from 'src/app/utils/swal';
import { AssigTripsService } from 'src/app/service/assigntrips-service/assigntrips-service';
import { CorporateService } from 'src/app/service/corporate-service/corporate-service';

@Component({
  selector: 'app-trip-activity-log',
  templateUrl: './trip-activity-log.component.html',
  styleUrls: ['./trip-activity-log.component.css']
})
export class TripActivityLogComponent implements OnInit {
  activityLog = [];
  search;
  @Input() tripData;
  @Output() onCloseModal = new EventEmitter<any>()

  preServiceAreas = {};
  preCooperates = {};


  constructor(
    private assignTripService: AssigTripsService,
    private serviceArea : ServiceAreasService,
    private corporateService : CorporateService
  ) { }

  ngOnInit() {
    console.log("Trip Data",this.tripData);
    this.getTripLog();
    this.getServiceAreas();
    this.getCorporate();
  }

  getTripLog() {
    this.assignTripService.getTripActivityLog(this.tripData._id)
      .pipe(takeUntil(componentDestroyed(this))).subscribe((data) => {
        console.log(data);
        if (data) {
          this.activityLog = data
        }
      })
  }

  getServiceAreas(){
    this.serviceArea.getServiceAreas({status: 'active'})
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.preServiceAreas = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        },
        (err) => {
          sweetAlert("Error", err, "error", "Ok");
        }
      );
    }

    getCorporate() {
      this.corporateService
        .getCorporateUsers('active')
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data ) {
            this.preCooperates = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
    }
  

  onClose() {
    this.onCloseModal.emit()
  }

  ngOnDestroy(): void {

  }
}
